import React from "react";
import { useLang } from "@/context/LanguageContext";

const BRANDS = ["BMW", "PORSCHE", "MERCEDES-AMG", "AUDI", "LAMBORGHINI", "FERRARI"];

export default function Marquee() {
  const { t } = useLang();
  const items = [...BRANDS, ...BRANDS];

  return (
    <section className="w-full overflow-hidden border-y border-white/10 py-10 bg-obsidian" data-testid="marquee-section">
      <div className="flex whitespace-nowrap animate-marquee">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center shrink-0">
            {items.map((b, i) => (
              <span key={`${dup}-${i}`} className="flex items-center">
                <span className="font-heading font-black uppercase tracking-tight text-5xl md:text-7xl text-stroke-white px-8">
                  {b}
                </span>
                <span className="text-brand-bright text-2xl md:text-4xl">/</span>
              </span>
            ))}
          </div>
        ))}
      </div>
      <div className="flex whitespace-nowrap animate-marquee mt-3" style={{ animationDirection: "reverse" }}>
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center shrink-0">
            {[...Array(6)].map((_, i) => (
              <span
                key={`${dup}-${i}`}
                className="font-heading font-black uppercase tracking-tight text-5xl md:text-7xl text-stroke px-10"
              >
                {t.marqueeWord}
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
